import {useMutation} from '@tanstack/react-query';

import {getExamsBooked} from '../../services/getExamsBooked';

export const useGetExamsBookedMutation = () => {
	return useMutation({
		mutationFn: getExamsBooked,
	});
};
